import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse, SourceType } from '@/shared/types';
import { MortgageWorkflowNoteDto } from '../types/workflow/mortgageNoteType';

// ---- Types (adjust to match your backend response) ----

// ---- API ----
export const mortgageWorkflowApi = createApi({
  reducerPath: 'mortgageWorkflowApi',
  baseQuery: customBaseQuery,
  tagTypes: ['MortgageWorkflowNote'],
  endpoints: (builder) => ({
    getNotesByService: builder.query<
      ApiResponse<MortgageWorkflowNoteDto>,
      { serviceName: SourceType; serviceId: string }
    >({
      query: ({ serviceName, serviceId }) => ({
        url: `/v1/mortgage-workflow/notes/by-service`,
        method: 'GET',
        params: { serviceName, serviceId },
      }),
    }),
  }),
});

export const { useGetNotesByServiceQuery } = mortgageWorkflowApi;
